import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostFollowRequest = {
	sonarObjectIds: Array<number>;
};

export const postFollow = createPostEndpoint<PostFollowRequest>('/api/v3/core/followers/follow');
